import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { UserState } from '../users/state/user.reducer';
import { LoginService } from './login.service';
import * as appActions from '../state/app.actions';
import { faSignInAlt } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  email = '';
  password = '';
  isLoggedIn = true;
  token = 'not defined';
  faSign = faSignInAlt;

  constructor(private loginService: LoginService, private router: Router, private store: Store<UserState>) { }

  ngOnInit() {
    this.loginService.isLoggedIn$.subscribe(res => {
      if (!res) {
        this.email = ''; this.password = '';
      } else {
        this.store.dispatch(new appActions.ToggleCurrentUser(this.loginService.currentUser));
      }

    });
  }

  onSubmit() {
    this.loginService.login(this.email, this.password);
  }

}
